import { render, staticRenderFns } from "./CreateEmployeeNotify.vue?vue&type=template&id=8028e22c&scoped=true"
import script from "./CreateEmployeeNotify.vue?vue&type=script&lang=js"
export * from "./CreateEmployeeNotify.vue?vue&type=script&lang=js"
import style0 from "./CreateEmployeeNotify.vue?vue&type=style&index=0&id=8028e22c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8028e22c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8028e22c')) {
      api.createRecord('8028e22c', component.options)
    } else {
      api.reload('8028e22c', component.options)
    }
    module.hot.accept("./CreateEmployeeNotify.vue?vue&type=template&id=8028e22c&scoped=true", function () {
      api.rerender('8028e22c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/employee/CreateEmployeeNotify.vue"
export default component.exports